import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";

export const AdyenIssueIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="To resolve issues related to Adyen, it’s most efficient to reach out to their support team directly. Here are a few key areas to check on before contacting their support:"
          description={{
            img: "https://cdn.faire.com/fastly/c416c8c98f5ded9858a9142a9ce9702867daa5aec1dc128cd93a9eb1ddc7431e.png",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Complete Your Account Setup</BoldFormatting>: Ensure your setup with Adyen was completed within 6 weeks. If not, your account may be temporarily suspended."
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
              description={{
                text: "The first step title in the Adyen issue guide",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Verify Your Account:</BoldFormatting> Make sure Adyen has verified your account. Your payouts won’t initiate until your bank account is verified by Adyen."
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
              description={{
                text: "The second step title in the Adyen issue guide",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Provide Required Information</BoldFormatting>: Adyen may request additional information for verification, especially once you reach a specified amount in sales (£1,000/€1,000/1,000 CHF). Ensure all requested information is provided."
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
              description={{
                text: "The third step title in the Adyen issue guide",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={4}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Check Account Type</BoldFormatting>: Confirm the account type (business or individual) you selected matches the type shown on your bank statement. This is crucial for account verification."
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
              description={{
                text: "The fourth step title in the Adyen issue guide",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
    </Column>
  );
};

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
